// @flow
import ModalSuccessOld from 'components/Modal/ModalSuccessOld'
import * as React from 'react'

import TimeSlotDescription from './TimeSlotDescription'

type Props = {
  location: {
    state: ?{
      timeslot: ?Date,
      duration: ?number,
    },
  },
}

function AppointmentScheduled({ location }: Props): React.Node {
  return (
    <ModalSuccessOld
      hideButton
      isVisible
      description={
        location.state?.timeslot ? (
          <TimeSlotDescription {...location.state} center noIcon withFooter />
        ) : null
      }
      title="The Appointment is scheduled"
    />
  )
}

export default AppointmentScheduled
